export enum EventType {
  AASHTOWARE_CREATED = 'Aashtoware Created',
  AASHTOWARE_DELETED = 'Aashtoware Deleted',
  AASHTOWARE_UPDATED = 'Aashtoware Updated',

  ARCGIS_CIVIL3D_COGO_POINTS_CREATED = 'ArcGIS Civil3D COGO Points Created',
  ARCGIS_CIVIL3D_COGO_POINTS_DELETED = 'ArcGIS Civil3D COGO Points Deleted',
  ARCGIS_CIVIL3D_COGO_POINTS_UPDATED = 'ArcGIS Civil3D COGO Points Updated',
  ARCGIS_CIVIL3D_COGO_POINT_UPDATED = 'ArcGIS Civil3D COGO Point Updated',

  ARCGIS_CIVIL3D_CONFIGURATION_CREATED = 'ArcGIS Civil3D Configuration Created',
  ARCGIS_CIVIL3D_CONFIGURATIONS_CREATED = 'ArcGIS Civil3D Configurations Created',
  ARCGIS_CIVIL3D_CONFIGURATION_DELETED = 'ArcGIS Civil3D Configuration Deleted',
  ARCGIS_CIVIL3D_CONFIGURATION_UPDATED = 'ArcGIS Civil3D Configuration Updated',

  ARCGIS_CIVIL3D_FEATURE_LINES_CREATED = 'ArcGIS Civil3D Feature Lines Created',
  ARCGIS_CIVIL3D_FEATURE_LINES_DELETED = 'ArcGIS Civil3D Feature Lines Deleted',
  ARCGIS_CIVIL3D_FEATURE_LINES_UPDATED = 'ArcGIS Civil3D Feature Lines Updated',
  ARCGIS_CIVIL3D_FEATURE_LINE_UPDATED = 'ArcGIS Civil3D Feature Line Updated',

  ARCGIS_CIVIL3D_ALIGNMENTS_CREATED = 'ArcGIS Civil3D Alignments Created',
  ARCGIS_CIVIL3D_ALIGNMENTS_DELETED = 'ArcGIS Civil3D Alignments Deleted',
  ARCGIS_CIVIL3D_ALIGNMENTS_UPDATED = 'ArcGIS Civil3D Alignments Updated',
  ARCGIS_CIVIL3D_ALIGNMENT_UPDATED = 'ArcGIS Civil3D Alignment Updated',

  ARCGIS_CIVIL3D_PARCELS_CREATED = 'ArcGIS Civil3D Parcels Created',
  ARCGIS_CIVIL3D_PARCELS_DELETED = 'ArcGIS Civil3D Parcels Deleted',
  ARCGIS_CIVIL3D_PARCELS_UPDATED = 'ArcGIS Civil3D Parcels Updated',
  ARCGIS_CIVIL3D_PARCEL_UPDATED = 'ArcGIS Civil3D Parcel Updated',

  ARCGIS_FEATURE_CLASS_CREATED = 'ArcGIS Feature Class Created',
  ARCGIS_FEATURE_CLASS_DELETED = 'ArcGIS Feature Class Deleted',
  ARCGIS_FEATURE_CLASS_UPDATED = 'ArcGIS Feature Class Updated',

  ARCGIS_SCHEMA_REQUESTED = 'ArcGIS Schema Requested',
  ARCGIS_SCHEMA_CREATED = 'ArcGIS Schema Created',

  AUTODESK_LAYER_CREATED = 'Autodesk Layer Created',
  AUTODESK_LAYER_DELETED = 'Autodesk Layer Deleted',
  AUTODESK_LAYER_UPDATED = 'Autodesk Layer Updated',

  BLOCKS_CREATED = 'Blocks Created',
  BLOCK_UPDATED = 'Block Updated',
  BLOCK_DELETED = 'Block Deleted',

  CONTRACT_CREATED = 'Contract Created',
  CONTRACT_DELETED = 'Contract Deleted',
  CONTRACT_UPDATED = 'Contract Updated',

  DOMAIN_CREATED = 'Domain Created',
  DOMAIN_DELETED = 'Domain Deleted',
  DOMAIN_UPDATED = 'Domain Updated',

  ONTOLOGY_ATTRIBUTE_CREATED = 'Ontology Attribute Created',
  ONTOLOGY_ATTRIBUTE_DELETED = 'Ontology Attribute Deleted',
  ONTOLOGY_ATTRIBUTE_UPDATED = 'Ontology Attribute Updated',
  ONTOLOGY_SURVEY_CODE_CREATED = 'Ontology Survey Code Created',
  ONTOLOGY_SURVEY_CODE_DELETED = 'Ontology Survey Code Deleted',
  ONTOLOGY_SURVEY_CODE_UPDATED = 'Ontology Survey Code Updated',
  ONTOLOGY_SURVEY_SUB_TYPE_CREATED = 'Ontology Survey Sub Type Created',
  ONTOLOGY_SURVEY_SUB_TYPE_DELETED = 'Ontology Survey Sub Type Deleted',
  ONTOLOGY_SURVEY_SUB_TYPE_UPDATED = 'Ontology Survey Sub Type Updated',

  POINT_STYLE_CREATED = 'Point Style Created',
  POINT_STYLE_DELETED = 'Point Style Deleted',
  POINT_STYLE_UPDATED = 'Point Style Updated',

  POINT_LABEL_STYLE_CREATED = 'Point Label Style Created',
  POINT_LABEL_STYLE_DELETED = 'Point Label Style Deleted',
  POINT_LABEL_STYLE_UPDATED = 'Point Label Style Updated',

  ROLE_CREATED = 'Role Created',
  ROLE_DELETED = 'Role Deleted',
  ROLE_UPDATED = 'Role Updated',

  SYMBOL_CREATED = 'Symbol / Line Type Created',
  SYMBOL_DELETED = 'Symbol / Line Type Deleted',
  SYMBOL_UPDATED = 'Symbol / Line Type Updated',
  SYMBOLS_SYNCED = 'Symbols / Line Types Synced',

  TEMPLATE_CREATED = 'Template Created',
  TEMPLATE_SYNCED = 'Template Synced',
  TEMPLATE_UPDATED = 'Template Updated',
  TEMPLATE_FILE_UPLOADED = 'Template File Uploaded',
  TEMPLATE_FILE_DELETED = 'Template File Deleted',

  TRIMBLE_LAYER_CREATED = 'Trimble Layer Created',
  TRIMBLE_LAYER_DELETED = 'Trimble Layer Deleted',
  TRIMBLE_LAYER_UPDATED = 'Trimble Layer Updated',
  TRIMBLE_LAYERS_SYNCED = 'Trimble Layers Synced',

  SETTINGS_UPDATED = 'Settings Updated',

  SYNC_PLANNED = 'Sync Planned',
  SYNC_APPLIED = 'Sync Applied',

  USER_CREATED = 'User Created',
  USER_DELETED = 'User Deleted',
  USER_UPDATED = 'User Updated',
  USER_PASSWORD_CHANGED = 'User Password Changed',
  USER_PASSWORD_RESET_REQUESTED = 'User Password Reset Requested',
}
